import { createFileRoute } from "@tanstack/react-router";

import React from "react";
import { ACL } from "src/components/acl";
import { useTranslation } from "react-i18next";
import { Subheading } from "src/components/base/heading";
import SINGLE_TAG_CONTEXT from "src/context/internal/tag";

/**
 * The properties for {@link TagOutboundACLs}
 */
export type TagOutboundACLsProps = {};

/**
 * Outbound ACLs of a group
 */
function TagOutboundACLs(props: TagOutboundACLsProps) {
    const [t] = useTranslation("admin-tag");

    const ctx = React.useContext(SINGLE_TAG_CONTEXT);

    return (
        <div className={"flex flex-col gap-6"}>
            {ctx.tag.locked ? undefined : (
                <>
                    <Subheading>{t("heading.add-new-acl")}</Subheading>
                    <ACL
                        key={"new-outbound"}
                        onChange={ctx.reset}
                        src={{ type: "Tag", value: ctx.tag }}
                        startEditable={true}
                    />
                </>
            )}

            <Subheading>{t("heading.existing-acls")}</Subheading>
            {ctx.tag.outbound_access_rules.map((acl) => (
                <ACL key={acl.uuid} src={acl.src} acl={acl} onChange={ctx.reset} />
            ))}
        </div>
    );
}

export const Route = createFileRoute("/_admin/a/tags/$tagId/_tags/outbound-acls")({
    component: TagOutboundACLs,
});
